// extracted by mini-css-extract-plugin
export default {"sizeCtn":"BuildAssetList_sizeCtn__GoeZB","addNewInstance":"BuildAssetList_addNewInstance__WWO6O"};